import SectionWrapper from "../layout/SectionWrapper";
import styled from "../../util/styled";

const PREFIX = "PricingSection";

export const classes = {
  container: `${PREFIX}-container`,
  subContainer: `${PREFIX}-subContainer`,
  buttonContainer: `${PREFIX}-buttonContainer`,
  button: `${PREFIX}-button`,
  buttonAgenda: `${PREFIX}-buttonAgenda`,
  buttonBudget: `${PREFIX}-buttonBudget`,
  buttonMetronome: `${PREFIX}-buttonMetronome`,
};

export const StyledSectionWrapper = styled(SectionWrapper)(({ theme }) => ({
  [`& .${classes.container}`]: {
    display: "flex",
    flexDirection: "column",
  },
  [`& .${classes.subContainer}`]: {
    margin: theme.spacing(2, 0),
  },
  [`& .${classes.buttonContainer}`]: {
    display: "flex",
    justifyContent: "space-evenly",
    [`& .${classes.button}`]: {
      padding: theme.spacing(2),
      [`&.${classes.buttonAgenda}`]: {
        backgroundColor: theme.palette.iaBlue.main,
        color: theme.palette.iaBlue.contrastText,
        "&:hover": {
          backgroundColor: theme.palette.iaBlue.light,
          color: theme.palette.iaBlue.dark,
        },
        "&:last-child": {
          backgroundColor: theme.palette.iaPink.main,
          color: theme.palette.iaPink.contrastText,
          "&:hover": {
            backgroundColor: theme.palette.iaPink.light,
            color: theme.palette.iaPink.dark,
          },
        },
      },
      [`&.${classes.buttonBudget}`]: {
        backgroundColor: theme.palette.ibGreen.main,
        color: theme.palette.ibGreen.contrastText,
        "&:hover": {
          backgroundColor: theme.palette.ibGreen.light,
          color: theme.palette.ibGreen.dark,
        },
        "&:last-child": {
          backgroundColor: theme.palette.ibPurple.main,
          color: theme.palette.ibPurple.contrastText,
          "&:hover": {
            backgroundColor: theme.palette.ibPurple.light,
            color: theme.palette.ibPurple.dark,
          },
        },
      },
      [`&.${classes.buttonMetronome}`]: {
        backgroundColor: theme.palette.ibOrange.main,
        color: theme.palette.ibOrange.contrastText,
        "&:hover": {
          backgroundColor: theme.palette.ibOrange.light,
          color: theme.palette.ibOrange.dark,
        },
        "&:last-child": {
          backgroundColor: theme.palette.ibPurple.main,
          color: theme.palette.ibPurple.contrastText,
          "&:hover": {
            backgroundColor: theme.palette.ibPurple.light,
            color: theme.palette.ibPurple.dark,
          },
        },
      },
    },
  },
}));
